/**
 * The graphics and design category id
 * @type {Number}
 */
export const GRAPHICS_AND_DESIGN_CAT_ID = 3;

/**
 * The logo design sub category id
 * @type {Number}
 */
export const LOGO_DESIGN_SUB_CAT_ID = 49;
